import React, { useEffect, useState } from 'react';
import { hasChildren } from './TeamUtils';
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { TableRow, TableCell, TableHead, TableBody, Table, Button, Grid, Alert } from '@mui/material';
import './Form.css';
import Select from 'react-select';
import { PeriodList } from '../../../../../utils/PeriodList'
import { CustomizedSnackbar } from '../../../../../shared';
import { axiosFetch } from '../../../../../utils/AxiosFetch';
import { useDispatch } from 'react-redux';
import { SnackbarActions } from '../../../../../redux/actions/snackbar.actions';
import { useNavigate } from 'react-router';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Menu from '@mui/material/Menu';
import { Divider, MenuItem } from '@mui/material';
import { IconButton } from '@mui/material';



var userDetails =
    localStorage.getItem("argus_user") !== null
        ? localStorage.getItem("argus_user")
        : null;
var userType =
    userDetails !== null && JSON.parse(userDetails).usertype !== null
        ? JSON.parse(userDetails).usertype
        : "";
var userid =
    userDetails !== null && JSON.parse(userDetails).userid !== null
        ? JSON.parse(userDetails).userid
        : "";
export default function TeamsList(props) {

    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [teamList, setTeamList] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    function getCurrentSessionDetails() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var value = null;
        if (currentMonth <= 6) {
            value = {
                lable: currentYear + "-" + 'H1',
                value: currentYear + "-" + 'H1'
            }

        }
        else {
            value = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        var list = PeriodList(3, "half");
        console.log(list);

        setSelectedPeriod(list.filter(list => list.value === value.value)[0]);
        // loadTeamDetails(value)
    }





    const handleChangePeriod = (obj) => {
        setSelectedPeriod(obj);
    }



    const loadTeamDetails = () => {


        axiosFetch({
            method: "post",
            url: `/performance/appraisal/search`,
            requestConfig: {
                "year": '2022',
                // "session": sessionObj.value.split('-')[1]
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    setTeamList(res.data.team);
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }

    const handleSearch = () => {
        loadTeamDetails(selectedPeriod);
    }

    const clearFilter = () => {
        setSelectedPeriod(null);
        setTeamList([]);
        getCurrentSessionDetails()
    }

    return (
        <Grid container>

            {props?.teamList?.length ? <Grid item xs={12}>


                <Table className='team-bg1'>
                    <TableHead>
                        <TableRow className='team-from-bg'>
                            <TableCell></TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Designation</TableCell>
                            <TableCell>Period</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Actions</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props?.teamList?.map((item, key) => <Item key={key} item={item} />)}
                    </TableBody>
                </Table>
            </Grid> : <Alert severity='error'>No Review History</Alert>}
        </Grid >
    )


}

const Item = ({ item }) => {
    const MenuComponent = hasChildren(item) ? MultiLevel : SingleLevel;
    return <MenuComponent item={item} />
};

const SingleLevel = ({ item }) => {

    const dispatch = useDispatch();
    const [btnName, setBtnName] = useState('');
    const navigate = useNavigate();
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open_Menu = Boolean(anchorEl);
    const [formId, setFormId] = useState('');
    const [statusId, setStatusId] = useState('');
    const [managerId, setManagerId] = useState('');
    const [reportingPersonId, setReportingPersonId] = useState('');
    const [isRestrictApprove, setIsRestrictApprove] = useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const toggleMenu = (event, statusId, reportingPersonId, formId, managerId) => {

        setFormId(formId)
        setStatusId(statusId);
        setReportingPersonId(reportingPersonId);
        setAnchorEl(event.currentTarget);
        setManagerId(managerId);

        if (localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid === reportingPersonId) {
            if (parseInt(statusId) === 7) {
                setBtnName('View');
            }
            setBtnName('Review');
        }
        else {
            // moved to HR
            if (parseInt(statusId) === 3) {
                setBtnName('Review')
            }
            else {
                setBtnName('View');
            }
        }
        if (localStorage.getItem('argus_user') !== null && JSON.parse(localStorage.getItem('argus_user')).userid == managerId) {
            if ((parseInt(statusId) === 3) || (parseInt(statusId) === 6)) {
                setIsRestrictApprove(true);
            }
            else {
                setIsRestrictApprove(false);
            }

        }
        else {
            setIsRestrictApprove(true);
        }

    };

    const handleView = (formId) => {

        // if (statusId !== '3' && parseInt(managerId) !== userid) {
        //     window.location.href = `/annual-appraisal-form/${formId}`;
        // }
        // else if (statusId === '3' && parseInt(managerId) !== userid) {
            navigate(`/value-analysis-form/${formId}`);
        // }
    }
    const handleClose = () => {
        setAnchorEl(null);
    };
    

    return (
        <>
            <TableRow>
                <TableCell className='tm-icon-wt'/>
                <TableCell className='tm-name-form'>
                    {item?.employeeName !== null ? item?.employeeName : '-'}
                </TableCell>
                <TableCell className='tm-mail-form'>{item?.emailId !== null ? item?.emailId : '-'}</TableCell>
                <TableCell className='tm-desg-form'>{item?.designation !== null ? item?.designation : '-'}</TableCell>
                <TableCell className='tm-prd-form'>{item?.period !== null ? item?.period : "-"}</TableCell>
                <TableCell className='tm-status-form'>{item?.statusName !== null ? item?.statusName : '-'}</TableCell>
                {console.log(userid)}
                <TableCell>
        
                {item.formId !== null?<Button
                onClick={()=>handleView(item.formId)}
                variant="contained" className={item.reportingPersonId === (JSON.parse(localStorage.getItem('argus_user')).userid)?"review":"view"}>
         {item.reportingPersonId === (JSON.parse(localStorage.getItem('argus_user')).userid)?"Review":"View"}
         </Button>:"-"}
                    {/* <IconButton className='view' onClick={(e) => toggleMenu(e, item.statusId, item.reportingPersonId, item.formId, item.reviewerManagerId)}><MoreHorizIcon /></IconButton> */}
                    </TableCell>
                {/* <TableCell align="right">{row.protein}</TableCell> */}
            </TableRow>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleView}>{btnName}</MenuItem>
                {/* <Divider />
                <MenuItem disabled={isRestrictApprove} onClick={handleApprove}>Approve</MenuItem> */}
            </Menu>
        </>

    );
};

const MultiLevel = ({ item }) => {
    const navigate = useNavigate();
    const { members: children } = item;
    const [open, setOpen] = useState(false);
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open_Menu = Boolean(anchorEl);
    const [formId, setFormId] = useState('');
    const [statusId, setStatusId] = useState('');
    const [managerId, setManagerId] = useState('');
    const [reportingPersonId, setReportingPersonId] = useState('')
    const [isRestrictApprove, setIsRestrictApprove] = useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [btnName, setBtnName] = useState('');

    const dispatch = useDispatch();

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openM = Boolean(anchorEl);   

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleApprove = () => {
        axiosFetch({
            url: `/performance/appraisal/complete/${formId}`,
            method: 'post',
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(SnackbarActions(true, "success", "Request Approved!"));
                    window.location.reload();
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", `${res.data}`));
                }
                else if (res.status === 401) {
                    window.location.href = '/';
                }
            })
    }

    const handleView = (formId) => {     
        // if (statusId !== '3' && parseInt(managerId) !== userid) {
        //     window.location.href = `/annual-appraisal-form/${formId}`;
        // }
        // else if (statusId === '3' && parseInt(managerId) !== userid) {
            navigate(`/value-analysis-form/${formId}`);
        // }
    }



    return (
        <React.Fragment>

            <TableRow className={open ? 'pf-lt-name team-line' : ''}>
                <TableCell className='tm-icon-wt'>
                    {open ? <ExpandLess onClick={handleClick} /> : <ExpandMore onClick={handleClick} />}
                </TableCell>
                <TableCell className='tm-name-form'>
                    {item.employeeName !== null ? item.employeeName : '-'}
                </TableCell>
                <TableCell className='tm-mail-form'>{item.emailId !== null ? item.emailId : '-'}</TableCell>
                <TableCell className='tm-desg-form'>{item.designation !== null ? item.designation : '-'}</TableCell>
                <TableCell className='tm-prd-form'>{item.period !== null ? item.period : "-"}</TableCell>
                <TableCell className='tm-status-form'>{item.statusName !== null ? item.statusName : '-'}</TableCell>
                <TableCell>
                {item.formId !== null?<Button
                onClick={()=>handleView(item.formId)}
                variant="contained" className={item.reportingPersonId === (JSON.parse(localStorage.getItem('argus_user')).userid)?"review":"view"}>
         {item.reportingPersonId === (JSON.parse(localStorage.getItem('argus_user')).userid)?"Review":"View"}
         </Button>:"-"}

                    {/* <IconButton className='view' onClick={(e) => toggleMenu(e, item.statusId, item.reportingPersonId, item.formId, item.reviewerManagerId)}><MoreHorizIcon /> */}
                    {/* </IconButton> */}
                    </TableCell>
            </TableRow>
            {open ?
                <TableRow>
                    <TableCell colSpan={12}>
                    <div className='tm-form-lt' >Team of {item.employeeName} </div>
                        <Collapse in={open} timeout="auto" unmountOnExit className='team-training-line'>
                            <Table className="inner-tm-line">
                                {children.map((child, key) => (
                                    <Item key={key} item={child} />
                                ))}
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>
                : ''}
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openM}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleView}>{btnName}</MenuItem>
                <Divider />
                <MenuItem disabled={isRestrictApprove} onClick={handleApprove}>Approve</MenuItem>

            </Menu>
        </React.Fragment>
    );
};